import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {unknownProjectionMeters} from '../projections/projections';

export interface Projection {
  type: string,
  name?: string,
  string: string,
  imported?: boolean,
  transform?: Transform
}

export interface Transform {
  origin: number[];
  translation: number[];
  rotation: number;
  scale: number;
}

interface ProjectionData {
  data: Projection;
  view: Projection;
  measureUnits: string
}

export const projectionsSlice = createSlice({
  name: 'projections',
  initialState: {
    data: unknownProjectionMeters,
    view: unknownProjectionMeters,
    measureUnits: "m"
  } as ProjectionData,
  reducers: {
    changeData: (state, action: PayloadAction<Projection>) => {
      state.data = action.payload;
    },
    changeView: (state, action: PayloadAction<Projection>) => {
      state.view = action.payload;
    },
    changeMeasureUnits: (state, action: PayloadAction<string>) => {
      state.measureUnits = action.payload;
    },
  }
});

export const {
  changeData,
  changeView,
  changeMeasureUnits
} = projectionsSlice.actions;

export default projectionsSlice.reducer;

export const selectView = state => state.projections.view;
export const selectData = state => state.projections.data;
export const selectMeasureUnits = state => state.projections.measureUnits;